import { MenuItem, Select } from "@mui/material";
import FormField from "../../../components/FormField";
import { useIsMobile } from "../../../hooks/useIsMobile";
import CloseIcon from "../../../components/CloseIcon";

const zoomLevels = [
  {
    value: 5,
    label: "Close",
  },
  {
    value: 10,
    label: "Medium",
  },
  {
    value: 15,
    label: "Far",
  },
];

const MapOptions = ({ close, onFooterSelect }: { close: () => void; onFooterSelect?: (tab: any) => void }) => {
  const isMobile = useIsMobile(768);

  const handleClose = () => {
    if (isMobile && onFooterSelect) {
      onFooterSelect('origins');
    }
    close();
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          position: "absolute",
          right: 10,
          top: 10,
          zIndex: 1013,
        }}
      >
        <CloseIcon onClick={handleClose} />
      </div>
      <div
        style={{
          overflowY: "auto",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          padding: isMobile ? 10 : 32,
          gap: 30,
        }}
      >
        {/* FILTER OPTIONS */}
        <div>
          <div
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "#595959",
              paddingBottom: 10,
            }}
          >
            Map settings
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            <FormField label="Zoom">
              <>
                <div
                  style={{
                    color: "#878787",
                    fontSize: 12,
                    fontStyle: "italic",
                  }}
                >
                  Default zoom level for the map
                </div>
                <Select style={{ width: 180 }} size="small">
                  {zoomLevels.map((level) => {
                    return (
                      <MenuItem key={level.value} value={level.value}>
                        {`${level.label} (${level.value})`}
                      </MenuItem>
                    );
                  })}
                </Select>
              </>
            </FormField>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapOptions;
